import { Common, color } from '@stockbit/ui';

import Image from 'global/Image';
import NotationPopover from './NotationPopover';
import { SyariahLabelWrapper } from './styled';

const { Text, Flex } = Common;

function CompanyLabel({ data }) {
  const { notation, corp_action, catalogs } = data;

  const checkIsSyariah = () => {
    const syariahCatalog = catalogs.find(
      ({ company_symbol }) => company_symbol === 'Syariah',
    );
    return syariahCatalog !== undefined;
  };

  return (
    <Flex align="center" justify="center" ml="10px">
      {notation.length !== 0 && <NotationPopover data={data} />}
      {corp_action.active && (
        <Image
          src="/icon/corp_action_event_icon.svg"
          alt="corp_action"
          style={{ marginLeft: '5px' }}
        />
      )}
      {checkIsSyariah() && (
        <SyariahLabelWrapper>
          <Text size="12px" color={color.primary}>
            Syariah
          </Text>
        </SyariahLabelWrapper>
      )}
    </Flex>
  );
}

export default CompanyLabel;
